import { newsRecommendationEndpoint, apiKey } from './constants';

export const getNewsRecommendation = async ({
  feature,
  userObjectId,
  clientObjectId,
  factsheets,
  tone,
  dialect,
  personality,
  lifeStage,
  language,
  emoji,
  news,
  freeText
}) => {
  if (!newsRecommendationEndpoint || !apiKey) {
    throw new Error('News Recommendation API endpoint or API key not configured');
  }
  const freeTags = freeText
    ? freeText
        .trim()
        .split('#')
        .filter(tag => tag.trim() !== '')
    : undefined;
  const freeTagsObject = freeTags ? Object.fromEntries(freeTags.map((tag, index) => [`tag${index}`, tag])) : undefined;
  const body = {
    userObjectId: userObjectId,
    feature: feature,
    clientObjectId: clientObjectId,
    topN: 2,
    message: 2,
    news: news ? [news] : undefined,
    clientTraits: {
      personality: personality,
      lifeStage: lifeStage,
      ...(freeTagsObject ? freeTagsObject : {})
    },
    factsheets: factsheets,
    emoji: emoji,
    language: language,
    dialect: dialect,
    tone: tone
  };

  const req = {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': apiKey
    }
  };

  console.log(' News Recommendation API: Request ::: ', req);
  const response = await fetch(newsRecommendationEndpoint, req);
  const result = await response.json();
  console.log(' News Recommendation API:  Result ::: ', result);
  return result;
};
